import type { ToastContainerProps } from 'react-toastify';
import { Slide } from 'react-toastify';

import type { CouponTypeTranslations } from '@/types';

export const couponTypeTranslations: CouponTypeTranslations = {
  ORDINAR: ['coupon.type.ordinar', 'Ordinar'],
  EXPRESS: ['coupon.type.express', 'Express'],
  SYSTEM: ['coupon.type.system', 'System'],
};

export const commonToastOptions: ToastContainerProps = {
  newestOnTop: false,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: false,
  icon: false,
  hideProgressBar: true,
  draggable: false,
  theme: 'dark',
  stacked: true,
  transition: Slide,
};

export const couponToastOptions: ToastContainerProps = {
  ...commonToastOptions,
  autoClose: false,
  limit: 1,
};

export const historyToastOptions = {
  ...commonToastOptions,
  autoClose: 5000,
  position: 'top-right',
};
